import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [role, setRole] = useState(localStorage.getItem("role") || null);
  const [email, setEmail] = useState(localStorage.getItem("email") || null);
  const [userId, setUserId] = useState(localStorage.getItem("user_id") || null);
  const [name, setName] = useState(localStorage.getItem("name") || null);

  const isAuthenticated = Boolean(token);

  const login = useCallback((data) => {
    localStorage.setItem("token", data.access_token);
    localStorage.setItem("role", data.role);
    localStorage.setItem("email", data.email);
    localStorage.setItem("user_id", data.id);
    localStorage.setItem("name", data.name || "");
    setToken(data.access_token);
    setRole(data.role);
    setEmail(data.email);
    setUserId(data.id);
    setName(data.name || "");
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("user_id");
    localStorage.removeItem("name");
    setToken(null);
    setRole(null);
    setEmail(null);
    setUserId(null);
    setName(null);
    navigate("/auth/signin");
  }, [navigate]);

  // Sync across tabs
  useEffect(() => {
    const onStorage = () => {
      setToken(localStorage.getItem("token"));
      setRole(localStorage.getItem("role"));
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <AuthContext.Provider
      value={{ token, role, email, userId, name, isAuthenticated, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
};

export default AuthContext;
